import { useMemo } from "react";
import { getUsageChart } from "../apis/workspace/billing";
import { useStoreUsageBilling } from "../stores/useStoreUsageBilling";
import { useSmartQuery } from "./useSmartQuery";

export const useUsageChart = (workspaceId, queryParams = {}) => {
  const { usageChartResponse, setUsageChart } = useStoreUsageBilling();

  const shouldFetch = !!workspaceId;

  const queryString = useMemo(() => {
    const validEntries = Object.entries(queryParams || {}).filter(([, value]) => {
      if (value === undefined || value === null) return false;
      if (typeof value === "string" && value.trim() === "") return false;
      return true;
    });

    if (validEntries.length === 0) {
      return "";
    }

    validEntries.sort(([a], [b]) => a.localeCompare(b));

    const searchParams = new URLSearchParams();

    validEntries.forEach(([key, value]) => {
      searchParams.set(key, value);
    });

    return searchParams.toString();
  }, [queryParams]);

  const query = useSmartQuery(
    ["get_usage_billing_chart", workspaceId, queryString],
    () =>
      getUsageChart({
        query: queryString,
        options: { headers: { "X-Workspace-Id": workspaceId } },
      }),
    {
      condition: shouldFetch, // ✅ No need to return early
      zustandSetter: setUsageChart,
    }
  );

  return {
    usageChartResponse,
    ...query,
  };
};
